export default {
    name: 'Advertisement'
}
